import {createBrowserRouter} from 'react-router-dom';
import App from '@/App.tsx';
import Request from '@pages/Request';
import NewRequest from '@pages/NewRequest';
import Tracking from '@pages/Tracking';
import AppChild from '@/appChild';
import MainPage from '@pages/MainPage';
import AdvancedTracking from '@pages/AdvancedTracking';
import Faq from '@pages/Faq';
import NewRequestInternal from '@pages/NewRequestInternal';
import {InternalContextProvider} from '@context/InternalContext';
import LanguageLayout from '@components/LanguageLayout';
import RedirectToDefaultLang from '@components/RedirectToDefaultLang';

const router = createBrowserRouter([
    // Backward-compat: bare paths redirect to /sk/... equivalent
    {path: '/', element: <RedirectToDefaultLang />},
    {path: '/tracking', element: <RedirectToDefaultLang />},
    {path: '/tracking/:shipmentNr', element: <RedirectToDefaultLang />},
    {path: '/advancedTracking', element: <RedirectToDefaultLang />},
    {path: '/request', element: <RedirectToDefaultLang />},
    {path: '/request/:id', element: <RedirectToDefaultLang />},
    {path: '/faq', element: <RedirectToDefaultLang />},
    {path: '/test', element: <RedirectToDefaultLang />},
    {path: '/internal/request', element: <RedirectToDefaultLang />},

    // All pages under /:lang — one shared App/AppContext for the entire app
    {
        path: '/:lang',
        element: <App><LanguageLayout /></App>,
        children: [
            {index: true, element: <MainPage />},
            {path: 'tracking', element: <MainPage />},
            {path: 'tracking/:shipmentNr', element: <Tracking />},
            {path: 'advancedTracking', element: <AdvancedTracking />},
            {path: 'request', element: <NewRequest />},
            {path: 'request/:id', element: <Request />},
            {path: 'faq', element: <Faq />},
            {path: 'test', element: <AppChild />},
            {
                path: 'internal/request',
                element: (
                    <InternalContextProvider>
                        <NewRequestInternal />
                    </InternalContextProvider>
                ),
            },
        ],
    },
]);

export default router;
